import { createContext } from 'react';

const axisContext = /*#__PURE__*/createContext("horisontal");

export { axisContext };
//# sourceMappingURL=context.js.map
